import React from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions
} from '@material-ui/core';

const VersionRefreshModal = ({ classes, versionRefreshModalIsOpen }) => {

  const getOSBasedInstruction = () => {
    let userAgent = window.navigator.userAgent;
    let getInstruction = (shortcut) => (`Please press ${shortcut} to clear your browser cache and reload the page`);

    if (userAgent.indexOf("Win") !== -1) {
      return getInstruction("Control + F5");
    } else if (userAgent.indexOf("Mac") !== - 1) {
      return getInstruction("Command + Shift + R");
    }
    return "Please clear your browser cache and reload the page";
  }

  return (
    <Dialog open={versionRefreshModalIsOpen} className={classes.dialog}>
      <DialogTitle>
        Cached version detected
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Your browser has cached an older version of ReVUe. {getOSBasedInstruction()}.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {/* Spacer */}
      </DialogActions>
    </Dialog>
  )
}

const styles = theme => ({
  dialog: {
    minWidth: '200px',
    minHeight: '150px'
  }
});

const mapState = state => ({
  versionRefreshModalIsOpen: state.appState.versionRefreshModalIsOpen
});

export default compose(
  withStyles(styles),
  connect(mapState)
)(VersionRefreshModal);